module.exports = __webpack_public_path__ + "img/jdp_logo.8fb95cf4.svg";